/**
 * Business industries. The business stores the code (same in every
 * language); labels come from `industry.<code>`. Anything else stored in
 * business.industry is free text typed under "Other" (and older businesses'
 * typed values) — shown as is.
 */
export const INDUSTRIES = [
  { code: 'retail', icon: 'storefront-outline' },
  { code: 'ecommerce', icon: 'cart-outline' },
  { code: 'wholesale_distribution', icon: 'cube-outline' },
  { code: 'food_beverage', icon: 'restaurant-outline' },
  { code: 'hospitality_travel', icon: 'bed-outline' },
  { code: 'real_estate', icon: 'home-outline' },
  { code: 'construction', icon: 'construct-outline' },
  { code: 'manufacturing', icon: 'cog-outline' },
  { code: 'healthcare', icon: 'medkit-outline' },
  { code: 'pharma_medical', icon: 'bandage-outline' },
  { code: 'beauty_wellness', icon: 'flower-outline' },
  { code: 'education_training', icon: 'school-outline' },
  { code: 'automotive', icon: 'car-sport-outline' },
  { code: 'logistics_shipping', icon: 'boat-outline' },
  { code: 'professional_services', icon: 'briefcase-outline' },
  { code: 'technology_software', icon: 'laptop-outline' },
  { code: 'marketing_media', icon: 'megaphone-outline' },
  { code: 'finance_insurance', icon: 'cash-outline' },
  { code: 'events', icon: 'sparkles-outline' },
  { code: 'home_services', icon: 'hammer-outline' },
  { code: 'fashion_apparel', icon: 'shirt-outline' },
  { code: 'electronics', icon: 'phone-portrait-outline' },
  { code: 'furniture_home', icon: 'bed-outline' },
  { code: 'agriculture_food', icon: 'leaf-outline' },
  { code: 'nonprofit', icon: 'heart-outline' },
  { code: 'other', icon: 'ellipsis-horizontal-circle-outline' },
] as const;

export type IndustryCode = typeof INDUSTRIES[number]['code'];

export const INDUSTRY_CODES: string[] = INDUSTRIES.map((i) => i.code);

export const isIndustryCode = (value?: string | null): value is IndustryCode =>
  !!value && INDUSTRY_CODES.includes(value);
